module.exports = __webpack_public_path__ + "22bd5ef8c856aaecc07c8597751d645e.png";